import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './MessageView.css';

interface MessageState {
  title?: string;
  message: string;
  type?: 'error' | 'info' | 'success' | 'warning';
}

export const MessageView: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as MessageState | null;

  // Default values if no state provided
  const title = state?.title || 'Hinweis';
  const message = state?.message || 'Es ist etwas passiert.';
  const type = state?.type || 'info';

  const getEmoji = () => {
    switch (type) {
      case 'error': return '❌';
      case 'warning': return '⚠️';
      case 'success': return '✅';
      default: return 'ℹ️';
    }
  };

  return (
    <div className="message-view">
      <div className={`message-view__card message-view__card--${type}`}>
        <span className="message-view__emoji">{getEmoji()}</span>
        <h1 className="message-view__title">{title}</h1>
        <p className="message-view__text">{message}</p>
        <button 
          className="message-view__button"
          onClick={() => navigate('/')}
        >
          Zurück zur Startseite
        </button>
      </div>
    </div>
  );
};
